import { useState } from "react";
import { FormBuilder } from "../../../../../types/FormBuilderInterfaces";
import { Field } from "../../../../../types/TenantInterfaces";
import { Button } from "reactstrap";
import { CheckPicker } from "rsuite";
import CollapseItem from "../../../components/CollapseItem";
import InputFormatter from "../../../../Records/Formatters/InputFormatter";
import useFieldMap from "../../../../../hooks/useFieldMap";
import { ItemDataType } from "rsuite/esm/MultiCascadeTree";

interface Props {
  form: FormBuilder;
  setForm: (value: any, key: string) => void;
  availableOptions: {
    label: string;
    value: string;
    group: string;
    item: Field;
  }[];
}

export default function HiddenFields({
  form,
  setForm,
  availableOptions,
}: Props) {
  const fieldMap = useFieldMap(form?.ModuleAPIName || "");
  const [addFieldOpen, setAddFieldOpen] = useState(false);

  const selectedFields = Object.keys(form?.Fields ?? {});
  const selectedHiddenFields = Object.keys(form?.HiddenFields ?? {});

  let hiddenFieldOptions = availableOptions.filter(
    (o) =>
      !selectedFields?.includes(o.value) &&
      !["Email", "Phone", "URL"].includes(fieldMap[o.value]?.FieldType)
  );
  // Add support for prefilling tags
  hiddenFieldOptions = [
    ...hiddenFieldOptions,
    {
      label: "Tags",
      value: "Tags",
      group: "",
      item: fieldMap?.["Tags"],
    },
  ];

  const handleDelete = (key: string) => {
    if (typeof key !== "string") return;

    const copy = { ...(form?.HiddenFields ?? {}) };

    if (form?.HiddenFields?.hasOwnProperty(key)) {
      delete copy[key];
    }

    setForm(copy, "HiddenFields");
  };

  return (
    <div>
      {!!selectedHiddenFields.length &&
        selectedHiddenFields.map((f) => {
          const field = fieldMap[f];

          return (
            <CollapseItem
              key={f}
              title={field?.Name}
              children={
                <>
                  <label className="text-sm font-weight-500">
                    {field?.Name}
                  </label>
                  {/* @ts-ignore */}
                  <InputFormatter
                    module={{ APIName: form.ModuleAPIName }}
                    field={field}
                    value={form?.HiddenFields?.[f] ?? ""}
                    // @ts-ignore
                    onChange={(_: any, val: any) => {
                      setForm(
                        { ...form?.HiddenFields, [f]: val },
                        "HiddenFields"
                      );
                    }}
                  />
                </>
              }
              onDelete={() => handleDelete(f)}
            />
          );
        })}
      <div className="d-flex justify-content-center">
        <Button
          className="mt-2"
          outline
          onClick={() => setAddFieldOpen(!addFieldOpen)}
        >
          {addFieldOpen ? "Hide Select" : "Manage Fields"}
        </Button>
      </div>
      {addFieldOpen && (
        <CheckPicker
          data={hiddenFieldOptions}
          placeholder="Select Fields"
          cleanable={false}
          onSelect={handleSelect}
          className="mt-2"
          block
          value={selectedHiddenFields}
          preventOverflow
        />
      )}
    </div>
  );

  function handleSelect(_: any, val: ItemDataType<string | number>) {
    const key = val.value;

    if (typeof key !== "string") return;

    const copy = { ...(form?.HiddenFields ?? {}) };

    if (form?.HiddenFields?.hasOwnProperty(key)) {
      delete copy[key];
    } else {
      copy[key] = "";
    }

    setForm(copy, "HiddenFields");
  }
}
